import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceCatalogScheme } from './service-catalog-scheme.model';
import * as ServiceCatalogSchemeActions from './service-catalog-scheme.actions';

export const serviceCatalogSchemesFeatureKey = 'serviceCatalogSchemes';

export interface State extends EntityState<ServiceCatalogScheme> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceCatalogScheme> = createEntityAdapter<ServiceCatalogScheme>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceCatalogSchemeActions.addServiceCatalogScheme,
    (state, action) => adapter.addOne(action.serviceCatalogScheme, state)
  ),
  on(ServiceCatalogSchemeActions.upsertServiceCatalogScheme,
    (state, action) => adapter.upsertOne(action.serviceCatalogScheme, state)
  ),
  on(ServiceCatalogSchemeActions.addServiceCatalogSchemes,
    (state, action) => adapter.addMany(action.serviceCatalogSchemes, state)
  ),
  on(ServiceCatalogSchemeActions.upsertServiceCatalogSchemes,
    (state, action) => adapter.upsertMany(action.serviceCatalogSchemes, state)
  ),
  on(ServiceCatalogSchemeActions.updateServiceCatalogScheme,
    (state, action) => adapter.updateOne(action.serviceCatalogScheme, state)
  ),
  on(ServiceCatalogSchemeActions.updateServiceCatalogSchemes,
    (state, action) => adapter.updateMany(action.serviceCatalogSchemes, state)
  ),
  on(ServiceCatalogSchemeActions.deleteServiceCatalogScheme,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceCatalogSchemeActions.deleteServiceCatalogSchemes,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceCatalogSchemeActions.loadServiceCatalogSchemes,
    (state, action) => adapter.setAll(action.serviceCatalogSchemes, state)
  ),
  on(ServiceCatalogSchemeActions.clearServiceCatalogSchemes,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
